module.exports = "/_next/static/images/8a10f60f3b6d4da7e9a0ed34db647f06-mockup-conta-fgts@1x.jpg.webp";